import useTypedContext from "hooks/useTypedContext";

import ScanSettingsFormWrapper from "../components/FormWrapper";
import ScanSettingsPageLayout from "../components/PageLayout";
import { ScanSettingsContextData } from "../Context";
import ScanSettingsWorkerPoolEdit from "./Edit";
import ScanSettingsWorkerPoolView from "./View";

const ScanSettingsWorkerPool = () => {
  const { canUpdateScan } = useTypedContext(ScanSettingsContextData);

  return (
    <ScanSettingsPageLayout
      title="Worker pool"
      description="Choose the private worker pool this scan runs on."
    >
      <ScanSettingsFormWrapper>
        {canUpdateScan.result ? <ScanSettingsWorkerPoolEdit /> : <ScanSettingsWorkerPoolView />}
      </ScanSettingsFormWrapper>
    </ScanSettingsPageLayout>
  );
};

export default ScanSettingsWorkerPool;
